import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SchedulesStaffCountTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      data_calculate_to_schedules_total_staffs_by_role_day: [],
      data_calculate_to_schedules_total_staffs_by_day: [],
      data_calculate_to_schedules_total_staffs: [],
      schedule_days: this.props.schedule_days,
    };
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.data_calculate_to_schedules_total_staffs_by_day !== 'undefined') {
      this.setState({
        data_calculate_to_schedules_total_staffs_by_role_day: newProps.data_calculate_to_schedules_total_staffs_by_role_day,
        data_calculate_to_schedules_total_staffs_by_day: newProps.data_calculate_to_schedules_total_staffs_by_day,
        data_calculate_to_schedules_total_staffs_by_group: newProps.data_calculate_to_schedules_total_staffs_by_group,
        schedule_days: newProps.schedule_days,
        loaded: 1,
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h4 className="pull-left">Total de colaboradores</h4>
  <div className="clearfix"></div>
  <hr/>
  <BootstrapTable data={self.state.data_calculate_to_schedules_total_staffs_by_group} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há escalas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn isKey={true} dataField="regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Regime de Trabalho</TableHeaderColumn>
    <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base</TableHeaderColumn>
    <TableHeaderColumn dataField="group" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Grupo</TableHeaderColumn>
    <TableHeaderColumn dataField="role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Função</TableHeaderColumn>
    <TableHeaderColumn dataField="total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total de Colaboradores</TableHeaderColumn>
  </BootstrapTable>
  <hr/>
  <h4 className="pull-left">Quantitativo Diário de Colaboradores</h4>
  <div className="clearfix"></div>
  <hr/>
  <div className="table-responsive">
    <table className="table table-hover tabled-striped table-bordered">
      <thead>
        <tr>
          <th>Base</th>
          <th>Função</th>
          <th>Regime</th>
          {Object.keys(self.props.schedule_days).map(function(k) {
            var day = self.props.schedule_days[k];
            return(
              <th>{day.day}</th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {Object.keys(self.state.data_calculate_to_schedules_total_staffs_by_day).map(function(k) {
          return (
            <tr>
              <td className="col-md-5">{self.state.data_calculate_to_schedules_total_staffs_by_day[k].base}</td>
              <td className="col-md-5">{self.state.data_calculate_to_schedules_total_staffs_by_day[k].role}</td>
              <td className="col-md-5">{self.state.data_calculate_to_schedules_total_staffs_by_day[k].regime}</td>
              {Object.keys(self.state.data_calculate_to_schedules_total_staffs_by_day[k].days).map(function(day) {
                return(
                  <th>{self.state.data_calculate_to_schedules_total_staffs_by_day[k].days[day].total}</th>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
  <hr/>
  <h4 className="pull-left">Total Diário de Colaboradores</h4>
  <div className="clearfix"></div>
  <hr/>
  <div className="table-responsive">
    <table className="table table-hover tabled-striped table-bordered">
      <thead>
        <tr>
          <th>Base</th>
          <th>Função</th>
          {Object.keys(self.props.schedule_days).map(function(k) {
            var day = self.props.schedule_days[k];
            return(
              <th>{day.day}</th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {Object.keys(self.state.data_calculate_to_schedules_total_staffs_by_role_day).map(function(k) {
          return (
            <tr>
              <td className="col-md-5">{self.state.data_calculate_to_schedules_total_staffs_by_role_day[k].base}</td>
              <td className="col-md-5">{self.state.data_calculate_to_schedules_total_staffs_by_role_day[k].role}</td>
              {Object.keys(self.state.data_calculate_to_schedules_total_staffs_by_role_day[k].days).map(function(day) {
                return(
                  <th>{self.state.data_calculate_to_schedules_total_staffs_by_role_day[k].days[day].total}</th>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
  <hr/>
</div>
    );
  }
}

export default SchedulesStaffCountTab;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesStaffCountTab.js